/** Audience registry — WHO the document speaks to. Industry-independent. */

export const AUDIENCES = [
  { id: 'kids', name: 'Kids' },
  { id: 'teens', name: 'Teens' },
  { id: 'parents', name: 'Parents' },
  { id: 'students', name: 'Students' },
  { id: 'women', name: 'Women' },
  { id: 'men', name: 'Men' },
  { id: 'professionals', name: 'Professionals' },
  { id: 'business-owners', name: 'Business Owners' },
  { id: 'families', name: 'Families' },
  { id: 'seniors', name: 'Seniors' },
  { id: 'luxury-customers', name: 'Luxury Customers' },
  { id: 'tourists', name: 'Tourists' },
  { id: 'couples', name: 'Couples' },
  { id: 'general-public', name: 'General Public' },
];
